export default __webpack_public_path__ + "static/media/metamask_steps_8.4ba6ec85.png";